export function isMobileWebView(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroidWebView = /wv|webview/.test(userAgent) || /android.*version\//.test(userAgent);
    const isiOSWebView = (window as any).webkit?.messageHandlers !== undefined;

    // Legacy checks for both platforms - only check if mobile device
  const isMobile = /android|iphone|ipod|ipad/i.test(userAgent);
  const legacyCheck =
    isMobile &&
    !(navigator as any).standalone &&
    typeof window.orientation !== 'undefined';

  return isAndroidWebView || isiOSWebView || legacyCheck;
}
